import React, { Component } from 'react';
import $ from 'jquery';

class ConfirmCancelModal extends Component{

    componentDidMount(){
        this.closeAction();
    }

    closeAction = () => {
       
        $('#ConfirmCancelModal').on('hidden.bs.modal', function () {
        });
    };
    firstAction = ()=>{
        const {firstBtnAction} = this.props
        $('#ConfirmCancelModal').modal('hide');
        firstBtnAction()
    }
    secondAction =()=>{
        const {secndBtnAction} = this.props
        $('#ConfirmCancelModal').modal('hide');
        secndBtnAction()
    }
    render() {
        const {title, firstBtnTitle, secndBtnTitle} = this.props;
        return (
                <div className="modal" tabIndex="-1" role="dialog" id="ConfirmCancelModal" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        
                        <div className="modal-body">
                            <p>{title}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"  onClick={()=>this.firstAction()}>{firstBtnTitle}</button>{/*CONFIRM BTN*/}
                            <button type="button" className="btn botonCorrect text-black" onClick={()=>this.secondAction()}>{secndBtnTitle}</button>{/*CANCEL BTN*/}
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }

}
export default ConfirmCancelModal;